import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import GroupQRModal from "./GroupQRModal";

const GenerateGroupQRModal = ({ show, setShow, qrUrls }) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);

    const [responseModal, setResponseModal] = useState(false);
    const [responseModalData, setResponseModalData] = useState(null);

    const onCreate = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/generate-group-qr`, {
            qrUrls,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setShow(false);
                setResponseModalData(res.data.data);
                setResponseModal(true);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Δημιουργία Group QR</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είστε σίγουροι ότι θέλετε να δημιουργήσετε Group QR από τα επιλεγμένα Δ.Α;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onCreate()} disabled={loading}>
                        Δημιουργία {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                    </Button>
                </Modal.Footer>
            </Modal>

            {responseModalData !== null && (
                <GroupQRModal
                    show={responseModal}
                    setShow={setResponseModal}
                    groupData={responseModalData}
                />
            )}
        </React.Fragment>
    );
}

export default GenerateGroupQRModal;